import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';

import { SubmitButton } from 'components';
import TunnelBox from '../common/TunnelBox';
import TunnelStep from '../common/TunnelStep';
import DistributorRoleChoice from './pedagogical-step/DistributorRoleChoice';

const DistributorTypeChoice = ({ roleName, onConfirm, handleNextStep, userStep }) => {
    const isResubmit = useMemo(() => userStep?.successfulAttemptsNumber > 0, [userStep]);

    return (
        <TunnelStep title={texts.DISTRIBUTOR_PEDAGOGIC} maxWidth={950}>
            <TunnelBox>
                <DistributorRoleChoice roleName={roleName} />
            </TunnelBox>
            <SubmitButton
                disabled={!roleName}
                onClick={isResubmit ? handleNextStep : onConfirm}
                text={texts.SUIVANT}
            />
        </TunnelStep>
    );
};

DistributorTypeChoice.propTypes = {
    roleName: PropTypes.string,
    onConfirm: PropTypes.func,
    handleNextStep: PropTypes.func,
    userStep: PropTypes.object,
};

export default DistributorTypeChoice;
